import {
    HtaArray,
    HtaConnectorType,
} from './types'
import HtaConnectorView from './HtaConnectorView'
import React from 'react'
import {TFunction} from 'i18next'
import {useTranslation} from 'react-i18next'

export const htaKeysOrder = [
    'patientBasicInfo',
    'contactReason',
    'patientInitialInfo',
    'patientHas',
    'patientCareNeeds',
    'patientHasNot',
    'patientDoesNotKnow',
    'ICD-10',
    'ICPC-2',
    'urgencyRecommendation',
    'triage',
    'selfCareInstructions',
]

export const getTranslation = (t: TFunction): {[key: string]: string} => ({
    'ICD-10': t('Possible ICD-10 codes'),
    'ICPC-2': t('Possible ICPC-2 codes'),
    'contactReason': t('Reason for contact'),
    'patientBasicInfo': t('The client'),
    'patientCareNeeds': t('Needs and additional information'),
    'patientDoesNotKnow': t('The client does not know if he/she has'),
    'patientHas': t('The client has'),
    'patientHasNot': t('The client does not have'),
    'patientInitialInfo': t('Background information'),
    'selfCareInstructions': t('Self-care instructions'),
    'triage': t('Triage'),
    'urgencyRecommendation': t('Urgency recommendation'),
})

const HtaConnector = ({hta}: { hta: HtaConnectorType }): React.ReactElement => {
    const {t} = useTranslation()

    const defaultState: HtaArray[] = []
    const [htaArray, setHtaArray] = React.useState(defaultState)
    const translations = getTranslation(t)


    React.useEffect(() => {
        setHtaArray(Object.entries(hta)
            .sort((a, b) => htaKeysOrder.indexOf(a[0]) - htaKeysOrder.indexOf(b[0]))
            .map((item) => [...item, translations[item[0]]]) as unknown as HtaArray[])
    }, [hta])

    return <HtaConnectorView hta={htaArray} />
}

export default HtaConnector
